import { ComponentProps, useContext } from 'react';
import Alert from '@pelckmans/elementis/components/alert';
import Dialog from '@pelckmans/elementis/components/dialog';
import MaterialDialogHeader from '../../../components/MaterialDialogHeader';
import ModalContext from '../../../../../contexts/ModalContext';
import { useTranslation } from 'react-i18next';

type NoPreviewModalProps = {
  id: string;
  headerProps: Pick<ComponentProps<typeof MaterialDialogHeader>, 'title' | 'tags' | 'titleTooltip'>;
  downloadUrl?: string;
};

export default function NoPreviewModal({ id, headerProps, downloadUrl }: NoPreviewModalProps) {
  const { t } = useTranslation();
  const { closeModal } = useContext(ModalContext);

  function handleClose() {
    closeModal(id);
  }

  return (
    <Dialog id={id} modal onClose={handleClose} size="md" aria-label={t('PAGES.TOC_LEVEL.MODALS.NO_PREVIEW.BODY.TEXT')}>
      <MaterialDialogHeader
        title={headerProps.title}
        onClose={handleClose}
        tags={headerProps.tags}
        downloadUrl={downloadUrl}
        titleTooltip={headerProps.titleTooltip}
      />
      <Dialog.Body
        alertGroupProps={{
          'aria-label': undefined,
          role: undefined,
          children: <Alert prominence="warning">{t('PAGES.TOC_LEVEL.MODALS.NO_PREVIEW.BODY.TEXT')}</Alert>,
        }}
      />
    </Dialog>
  );
}
